module.exports = __webpack_public_path__ + "static/media/28DGC9.bcfb6ebc.jpg";